<template>
    <app-dialog width="500px" :value="value" :title="$t('sendAccount.title')" v-bind="$attrs" @input="onDialogInput">
        <template v-slot:content>
            <v-form ref="form">
                <div class="d-flex pb-2 justify-center align-center">
                    <v-text-field v-model="name" :rules="[rules.required]" required dense class="left-input">
                        <template v-slot:label>
                            <span>{{ $t('userDetails.name') }}&nbsp;</span>
                        </template>
                    </v-text-field>
                </div>

                <div class="d-flex justify-center align-center">
                    <v-text-field v-model="email" :rules="[rules.required, rules.email]" type="email" required dense class="left-input">
                        <template v-slot:label>
                            <span>Email&nbsp;</span>
                        </template>
                    </v-text-field>
                </div>
            </v-form>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text outlined class="myprovet-btn-cancel" @click="onCloseDialog"> {{ $t('common.cancel') }} </v-btn>

            <v-btn text class="myprovet-btn-ok" :loading="isLoading" @click="sendEmail"> {{ $t('sendAccount.send') }} </v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { i18n } from '@/i18n';
import { axios } from '@/Services/Backend';
import { buildQueryObjectFromModel } from '@arentia/atools/QueryBuilder';

export default {
    data() {
        return {
            name: '',
            email: '',
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                email: function (value) {
                    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return value && re.test(value) ? true : i18n.t('userDetails.rules.invalidEmail');
                },
            },
            isLoading: false,
        };
    },

    created() {
        this.name = '';
        this.email = '';
    },

    props: {
        value: { default: false },
        queryParams: Object,
        filters: Object,
        schema: Object,
    },

    methods: {
        sendEmail() {
            if (!this.$refs.form.validate()) return;

            this.isLoading = true;

            const queryObject = buildQueryObjectFromModel(this.filters, this.schema);

            axios
                .get('/api/financial/checking-account/email', {
                    params: {
                        name: this.name,
                        email: this.email,
                        queryObject: JSON.stringify(queryObject),
                        ...this.queryParams,
                    },
                })
                .then(() => {
                    this.showSuccess(this.$t('sendAccount.sent', { email: this.email }));
                    this.isLoading = false;
                    this.$emit('on-success', true);
                })
                .catch(() => {
                    this.showError(this.$t('sendAccount.error'));
                    this.isLoading = false;
                });
        },

        onDialogInput(event) {
            if (!event) {
                this.$emit('on-cancel', false);
            }
        },

        onCloseDialog() {
            this.$emit('on-cancel', false);
        },
    },
};
</script>
